import CampaignSettingCard from "./CampaignSettingCard";

export default CampaignSettingCard;

export { CampaignSettingCard };
